import React, { useState } from 'react';
import Button from '../../ui/Button';

const BusinessTypeStep = ({ onNext, onBack, initialData = {} }) => {
  const [selectedType, setSelectedType] = useState(initialData.businessType || '');
  const [searchTerm, setSearchTerm] = useState('');

  const businessTypes = [
    {
      id: 'salao',
      label: 'Salão de Beleza',
      icon: '💇‍♀️',
      color: 'bg-pink-50 border-pink-200'
    },
    {
      id: 'estetica',
      label: 'Clínica de Estética',
      icon: '✨',
      color: 'bg-purple-50 border-purple-200'
    },
    {
      id: 'barbearia',
      label: 'Barbearia',
      icon: '💈',
      color: 'bg-red-50 border-red-200'
    },
    {
      id: 'podologia',
      label: 'Podologia',
      icon: '👣',
      color: 'bg-blue-50 border-blue-200'
    },
    {
      id: 'esmalteria',
      label: 'Esmalteria',
      icon: '💅',
      color: 'bg-pink-50 border-pink-200'
    },
    {
      id: 'clinicamedica',
      label: 'Clínica médica',
      icon: '👨‍⚕️',
      color: 'bg-green-50 border-green-200'
    },
    {
      id: 'spa',
      label: 'SPA e massagem',
      icon: '🧖‍♀️',
      color: 'bg-teal-50 border-teal-200'
    },
    {
      id: 'pet',
      label: 'Pet e Veterinário',
      icon: '🐾',
      color: 'bg-yellow-50 border-yellow-200'
    },
    {
      id: 'tatuagem',
      label: 'Estúdio de tatuagem',
      icon: '🎨',
      color: 'bg-indigo-50 border-indigo-200'
    },
    {
      id: 'odontologia',
      label: 'Clínica odontológica',
      icon: '🦷',
      color: 'bg-blue-50 border-blue-200'
    },
    {
      id: 'fitness',
      label: 'Personal e fitness',
      icon: '💪',
      color: 'bg-orange-50 border-orange-200'
    },
    {
      id: 'outros',
      label: 'Outros segmentos',
      icon: '🏢',
      color: 'bg-gray-50 border-gray-200'
    }
  ];

  const filteredTypes = businessTypes.filter(type => 
    type.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleContinue = () => {
    if (selectedType) {
      onNext({ 
        businessType: selectedType,
        businessTypeName: businessTypes.find(t => t.id === selectedType)?.label || ''
      });
    }
  };

  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl font-semibold text-center text-gray-800 mb-3">
        Qual é o seu segmento?
      </h2>
      <p className="text-gray-600 text-center mb-6">
        Isso nos ajudará a configurar seus templates e serviços padrão
      </p>

      <div className="mb-6">
        <div className="relative">
          <input
            type="text"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="Buscar segmento..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8 max-h-[420px] overflow-y-auto pr-1">
        {filteredTypes.map((type) => (
          <div
            key={type.id}
            onClick={() => setSelectedType(type.id)}
            className={`border rounded-lg p-3 cursor-pointer transition-all hover:shadow-md ${
              selectedType === type.id
                ? `${type.color} border-2 shadow-md`
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="flex flex-col items-center text-center py-2">
              <div className="text-3xl mb-2">{type.icon}</div>
              <h3 className="font-medium text-sm text-gray-800">{type.label}</h3>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack}>
          Voltar
        </Button>
        <Button
          type="button"
          onClick={handleContinue}
          disabled={!selectedType}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default BusinessTypeStep; 